import { render, staticRenderFns } from "./ViewEvaluate.vue?vue&type=template&id=4c4d6c7b&scoped=true"
import script from "./ViewEvaluate.vue?vue&type=script&lang=js"
export * from "./ViewEvaluate.vue?vue&type=script&lang=js"
import style0 from "./ViewEvaluate.vue?vue&type=style&index=0&id=4c4d6c7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d6c7b",
  null
  
)

export default component.exports